<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import "multi-range-slider-vue/MultiRangeSliderBarOnly.css";
import {
  GET_COMPANY,
  UPDATE_COMPANY_CONFIGURATION,
} from "@/services/api/master/companies";
import Swal from "sweetalert2";
import { minValue } from "vuelidate/lib/validators";
import { Helper } from "@/mixin/helper";

/**
 * Starter component
 */
export default {
  page: {
    title: "Konfigurasi",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  mixins: [Helper],
  data() {
    return {
      title: "Konfigurasi",
      items: [
        {
          text: "Configuration",
        },
      ],
      company: {},
      companyIndex: [],
      companyId: this.getCompanyId(),
    };
  },
  validations: {
    company: {
      dsInitialInterval: { minValue: minValue(0) },
      dsInitialBonus: { minValue: minValue(0) },
      dsInterval: { minValue: minValue(0) },
      dsBonus: { minValue: minValue(0) },
      dsCostAccel: { minValue: minValue(0) },
      dsCostOverspeed: { minValue: minValue(0) },
      dsCostBrake: { minValue: minValue(0) },
      dsCostSharpturn: { minValue: minValue(0) },
    },
  },
  computed: {
    listIndeks() {
      return [
        {
          key: "index",
          label: "Indeks",
          sortable: true,
          type: "data",
        },
        {
          key: "dsMinScore",
          label: "Batas",
          sortable: true,
        },
      ];
    },
  },
  async mounted() {
    this.company = await this.getData();
    await this.mapIndex(this.company);
  },

  methods: {
    async mapIndex() {
      this.companyIndex = [
        {
          id: 1,
          index: "A",
          dsMinScore: "Lebih dari 80",
        },
        {
          id: 2,
          index: "B",
          dsMinScore: "61 - 80",
        },
        {
          id: 3,
          index: "C",
          dsMinScore: "41 - 60",
        },
        {
          id: 4,
          index: "D",
          dsMinScore: "21 - 40",
        },
        {
          id: 5,
          index: "E",
          dsMinScore: "Kurang dari 21",
        },
      ];
    },
    async getData() {
      try {
        const res = await this.$apollo.query({
          query: GET_COMPANY,
          variables: {
            filter: { id: this.companyId },
          },
        });
        return res.data.company.company;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async save() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      try {
        const input = {
          dsInitialInterval: Number(this.company.dsInitialInterval),
          dsInitialBonus: Number(this.company.dsInitialBonus),
          dsInterval: Number(this.company.dsInterval),
          dsBonus: Number(this.company.dsBonus),
          dsCostAccel: Number(this.company.dsCostAccel),
          dsCostOverspeed: Number(this.company.dsCostOverspeed),
          dsCostBrake: Number(this.company.dsCostBrake),
          dsCostSharpturn: Number(this.company.dsCostSharpturn),
          id: Number(this.company.id),
          dsIntervalType: 1,
        };

        const res = await this.$apollo.mutate({
          mutation: UPDATE_COMPANY_CONFIGURATION,
          variables: {
            input: input,
          },
        });
        Swal.fire({
          title: "Simpan Berhasil",
          text: "Perubahan Konfigurasi Skor Pengemudi Berhasil",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });

        return res;
      } catch (e) {
        console.log(e);
      }
    },
    isNumber(event) {
      event = (event) ? event : window.event;
      var charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        event.preventDefault();
      } else {
        return true;
      }
    }
  },
};
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <p>Mengatur parameter Skor Pengemudi</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            variant="outline-primary"
            @click="$router.push({ name: 'List Driver Score' })"
            class="mx-2"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t("global.back") }}
          </b-button>

          <b-button @click="save" variant="primary"
            ><i class="mc-fa icon-outline_save"></i>
            {{ $t("global.save") }}
          </b-button>
        </div>
      </div>
    </div>

    <h4 class="card-title">Penambahan Skor</h4>
    <b-card>
      <div class="row">
        <div class="col-md-6">
          <b-card class="mb-0 border border-1">
            <h5 class="card-title mb-3 pb-3 border-1 border-bottom">
              Penambahan Skor Awal
            </h5>
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Jarak Minimal (Km)">
                  <b-form-input
                    type="number"
                    @keypress="isNumber($event)"
                    v-model="company.dsInitialInterval"
                    :class="{
                      'is-invalid': $v.company.dsInitialInterval.$error,
                    }"
                    min="0"
                  ></b-form-input>
                  <div
                    v-if="$v.company.dsInitialInterval.$error"
                    class="invalid-feedback"
                  >
                    <span>
                      Jarak Minimal tidak bisa lebih kecil dari 0 (nol)
                    </span>
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Skor Awal">
                  <b-form-input
                    type="number"
                    @keypress="isNumber($event)"
                    v-model="company.dsInitialBonus"
                    :class="{
                      'is-invalid': $v.company.dsInitialBonus.$error,
                    }"
                    min="0"
                  ></b-form-input>
                  <div
                    v-if="$v.company.dsInitialBonus.$error"
                    class="invalid-feedback"
                  >
                    <span> Skor Awal tidak bisa lebih kecil dari 0 (nol) </span>
                  </div>
                </b-form-group>
              </div>
            </div>
          </b-card>
        </div>
        <div class="col-md-6">
          <b-card class="mb-0 border border-1">
            <h5 class="card-title mb-3 pb-3 border-1 border-bottom">
              Penambahan interval
            </h5>
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Interval (Km)">
                  <b-form-input
                    type="number"
                    @keypress="isNumber($event)"
                    v-model="company.dsInterval"
                    :class="{
                      'is-invalid': $v.company.dsInterval.$error,
                    }"
                    min="0"
                  ></b-form-input>
                  <div
                    v-if="$v.company.dsInterval.$error"
                    class="invalid-feedback"
                  >
                    <span> Interval tidak bisa lebih kecil dari 0 (nol) </span>
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Skor Tambahan">
                  <b-form-input
                    type="number"
                    @keypress="isNumber($event)"
                    v-model="company.dsBonus"
                    :class="{
                      'is-invalid': $v.company.dsBonus.$error,
                    }"
                    min="0"
                  ></b-form-input>
                  <div
                    v-if="$v.company.dsBonus.$error"
                    class="invalid-feedback"
                  >
                    <span>
                      Skor Tambahan tidak bisa lebih kecil dari 0 (nol)
                    </span>
                  </div>
                </b-form-group>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-card>

    <h4 class="card-title">Pengurangan Skor</h4>
    <b-card>
      <div class="row">
        <div class="col-md-3">
          <b-form-group label="Akselerasi Mendadak">
            <b-form-input
              type="number"
              @keypress="isNumber($event)"
              v-model="company.dsCostAccel"
              :class="{
                'is-invalid': $v.company.dsCostAccel.$error,
              }"
              min="0"
            ></b-form-input>
            <div v-if="$v.company.dsCostAccel.$error" class="invalid-feedback">
              <span>
                Akselerasi Mendadak tidak bisa lebih kecil dari 0 (nol)
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Kecapatan Melebihi Batas Aman">
            <b-form-input
              type="number"
              @keypress="isNumber($event)"
              v-model="company.dsCostOverspeed"
              :class="{
                'is-invalid': $v.company.dsCostOverspeed.$error,
              }"
              min="0"
            ></b-form-input>
            <div
              v-if="$v.company.dsCostOverspeed.$error"
              class="invalid-feedback"
            >
              <span>
                Kecepatan Melebihi Batas Aman tidak bisa lebih kecil dari 0
                (nol)
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Perlambatan Mendadak">
            <b-form-input
              type="number"
              @keypress="isNumber($event)"
              v-model="company.dsCostBrake"
              :class="{
                'is-invalid': $v.company.dsCostBrake.$error,
              }"
              min="0"
            ></b-form-input>
            <div v-if="$v.company.dsCostBrake.$error" class="invalid-feedback">
              <span>
                Perlambatan Mendadak tidak bisa lebih kecil dari 0 (nol)
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Tikungan Tajam">
            <b-form-input
              type="number"
              @keypress="isNumber($event)"
              v-model="company.dsCostSharpturn"
              :class="{
                'is-invalid': $v.company.dsCostSharpturn.$error,
              }"
              min="0"
            ></b-form-input>
            <div
              v-if="$v.company.dsCostSharpturn.$error"
              class="invalid-feedback"
            >
              <span> Tikungan Tajam tidak bisa lebih kecil dari 0 (nol) </span>
            </div>
          </b-form-group>
        </div>
      </div>
    </b-card>

    <h4 class="card-title">Indeks</h4>
    <b-card>
      <b-col sm="12" md="12">
        <div class="row">
          <div class="table-responsive my-3 border border-1">
            <b-table
              small
              show-empty
              :fields="listIndeks"
              :items="companyIndex"
              class="datatables"
              responsive="sm"
              empty-table
              :empty-text="$t('global.emptyTable')"
            ></b-table>
          </div>
        </div>
      </b-col>
    </b-card>
  </Layout>
</template>